import { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import { authContext } from "../contexts/AuthProvider";
import { mobileMenuContext } from "../contexts/MobileMenuProvider";
import UserMenu from "./UserMenu";
import ThemeMenu from "./ThemeMenu";
import { Link } from "react-router-dom";

const Header = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showThemeMenu, setShowThemeMenu] = useState(false);
  const { isAuth } = useContext(authContext);
  const { setOpenMenu } = useContext(mobileMenuContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  useEffect(() => {
    if (isAuth === false) {
      navigate("/login");
    }
  }, [isAuth]);

  return (
    <div id="kt_header" className="header">
      {/*begin::Header top*/}
      <div className="header-top d-flex align-items-stretch flex-grow-1">
        {/*begin::Container*/}
        <div className="d-flex  container-xxl  align-items-stretch">
          {/*begin::Brand*/}
          <div className="d-flex align-items-center align-items-lg-stretch me-5 flex-row-fluid">
            {/*begin::Heaeder navs toggle*/}
            <button
              onClick={() => {
                setOpenMenu((prev) => !prev);
              }}
              className="d-lg-none btn btn-icon btn-color-white bg-hover-white bg-hover-opacity-10 w-35px h-35px h-md-40px w-md-40px ms-n3 me-2"
              id="kt_header_navs_toggle"
            >
              <i className="ki-duotone ki-abstract-14 fs-2">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>{" "}
            </button>
            {/*end::Heaeder navs toggle*/}

            {/*begin::Logo*/}
            <Link to="/" className="d-flex align-items-center">
              <img
                alt="Logo"
                src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/logos/logo-light.png`}
                style={{ width: "80px" }}
              />
            </Link>
            {/*end::Logo*/}

            {/*begin::Tabs wrapper*/}
            <div className="align-self-end overflow-auto" id="kt_brand_tabs">
              {/*begin::Header tabs wrapper*/}
              <div
                className="header-tabs overflow-auto mx-4 ms-lg-10 mb-5 mb-lg-0"
                id="kt_header_tabs"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_header_navs_wrapper', lg: '#kt_brand_tabs'}"
              >
                {/*begin::Header tabs*/}
                <ul className="nav flex-nowrap text-nowrap">
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/dashboard/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/dashboard"
                    >
                      Overview
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/merchants/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/merchants/all-merchants"
                    >
                      Merchants
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/drivers/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/drivers/all-drivers"
                    >
                      Drivers
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/orders/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/orders/all-orders"
                    >
                      Orders
                    </Link>
                  </li>{" "}
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath(
                          { path: "/delivary-companies/*" },
                          pathname,
                        ) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/delivary-companies/all-delivary-companies"
                    >
                      Delivery Companies
                    </Link>
                  </li>{" "}
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/archive/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/archive/merchants"
                    >
                      Archive
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/settings/*" }, pathname) !== null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/settings/configure-roles"
                    >
                      Settings
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        pathname &&
                        matchPath({ path: "/integrations/*" }, pathname) !==
                          null
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/integrations/ordable"
                    >
                      Integrations
                    </Link>
                  </li>
                </ul>
                {/*begin::Header tabs*/}
              </div>
              {/*end::Header tabs wrapper*/}{" "}
            </div>
            {/*end::Tabs wrapper*/}
          </div>
          {/*end::Brand*/}
          {/*begin::Topbar*/}
          <div className="d-flex align-items-center flex-row-auto">
            {/*begin::Theme mode*/}

            <div
              className="d-flex align-items-center ms-1 p-2 theme-mode-wrapper"
              onMouseEnter={() => {
                setShowThemeMenu(true);
              }}
              onMouseLeave={() => {
                setShowThemeMenu(false);
              }}
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end"
            >
              {/*begin::Menu toggle*/}
              <div
                style={{ cursor: "pointer" }}
                className="btn btn-icon btn-color-white bg-hover-white bg-hover-opacity-10 w-35px h-35px h-md-40px w-md-40px theme-mode-toggle"
              >
                <i className="ki-duotone ki-night-day theme-light-show fs-2">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                </i>{" "}
                <i className="ki-duotone ki-moon theme-dark-show fs-2">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </div>
              {/*begin::Menu toggle*/}

              {/*begin::Menu*/}
              {showThemeMenu && (
                <ThemeMenu setShowThemeMenu={setShowThemeMenu} />
              )}
              {/*end::Menu*/}
            </div>
            {/*end::Theme mode*/}

            {/*begin::User*/}
            <div
              onMouseEnter={() => {
                setShowUserMenu(true);
              }}
              onMouseLeave={() => {
                setShowUserMenu(false);
              }}
              className="d-flex align-items-center ms-1 user-menu-wrapper"
              id="kt_header_user_menu_toggle"
            >
              {/*begin::User info*/}
              <div
                className="btn btn-flex align-items-center bg-hover-white bg-hover-opacity-10 py-2 ps-2 pe-2 me-n2"
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
              >
                {/*begin::Name*/}
                <div className="d-none d-md-flex flex-column align-items-end justify-content-center me-2 me-md-4">
                  <span className="text-white opacity-75 fs-8 fw-semibold lh-1 mb-1">
                    {process.env.REACT_APP_BRAND_NAME || ""}
                  </span>
                  <span className="text-white fs-8 fw-bold lh-1">
                    Admin Panel
                  </span>
                </div>
                {/*end::Name*/}

                {/*begin::Symbol*/}
                <div className="symbol symbol-30px symbol-md-40px">
                  <img
                    src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/avatars/user.png`}
                    alt="image"
                  />
                </div>
                {/*end::Symbol*/}
              </div>
              {/*end::User info*/}

              {/*begin::User account menu*/}
              {showUserMenu && <UserMenu />}
              {/*end::User account menu*/}
            </div>
            {/*end::User */}
          </div>
          {/*end::Topbar*/}{" "}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header top*/}

      {/*begin::Header navs*/}
      <div
        className="header-navs d-flex align-items-stretch flex-stack h-lg-70px w-100 py-5 py-lg-0 overflow-hidden overflow-lg-visible"
        id="kt_header_navs"
        data-kt-drawer="true"
        data-kt-drawer-name="header-menu"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="{default:'200px', '300px': '250px'}"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_header_navs_toggle"
        data-kt-swapper="true"
        data-kt-swapper-mode="append"
        data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header'}"
      >
        {/*begin::Container*/}
        <div className="d-lg-flex  container-xxl  w-100">
          {/*begin::Wrapper*/}
          <div
            className="d-lg-flex flex-column justify-content-lg-center w-100"
            id="kt_header_navs_wrapper"
          >
            {/*begin::Header tab content*/}
            <div
              className="tab-content"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: true, lg: false}"
              data-kt-scroll-height="auto"
              data-kt-scroll-offset="70px"
            >
              {/*begin::Tab panel*/}
              {pathname &&
              matchPath({ path: "/dashboard/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_1"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/dashboard"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/dashboard"
                      >
                        Driver Map
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/dashboard/ongoing-orders"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/dashboard/ongoing-orders"
                      >
                        Ongoing Orders
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/merchants/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/merchants/all-merchants"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/all-merchants"
                      >
                        All Merchants
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/merchants/create-merchant"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/create-merchant"
                      >
                        Create New
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/merchants/groups"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/groups"
                      >
                        Groups
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/merchants/pricing-sheet"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/pricing-sheet"
                      >
                        Pricing Sheet
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/merchants/all-transactions"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/all-transactions"
                      >
                        All Transactions
                      </Link>
                      <Link
                        className={
                          pathname &&
                          pathname === "/merchants/all-notifications"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/merchants/all-notifications"
                      >
                        Notifications
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/drivers/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/drivers/all-drivers"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/drivers/all-drivers"
                      >
                        All Drivers
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/drivers/create-driver"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/drivers/create-driver"
                      >
                        Create New
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/orders/*" }, pathname) !== null ? (
                <div className="tab-pane fade active show">
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/orders/all-orders"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/orders/all-orders"
                      >
                        All Orders
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/delivary-companies/*" }, pathname) !==
                null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname &&
                          pathname ===
                            "/delivary-companies/all-delivary-companies"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/delivary-companies/all-delivary-companies"
                      >
                        All Companies
                      </Link>
                      <Link
                        className={
                          pathname &&
                          pathname ===
                            "/delivary-companies/create-delivary-company"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/delivary-companies/create-delivary-company"
                      >
                        Create New
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/archive/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/archive/merchants"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/archive/merchants"
                      >
                        Merchants
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/archive/drivers"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/archive/drivers"
                      >
                        Drivers
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/archive/employees"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/archive/employees"
                      >
                        Employees
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/archive/delivary-companies"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/archive/delivary-companies"
                      >
                        Delivary Companies
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/settings/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/settings/configure-roles"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/configure-roles"
                      >
                        Configure Roles
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/settings/user-role"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/user-role"
                      >
                        User Role
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/settings/driver-sharing"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/driver-sharing"
                      >
                        Driver Sharing
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/settings/pricing-model"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/pricing-model"
                      >
                        Pricing Model
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/settings/revenue-stat"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/revenue-stat"
                      >
                        Revenue Stat
                      </Link>
                      <Link
                        className={
                          pathname && pathname === "/settings/driver-report"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/settings/driver-report"
                      >
                        Driver Report
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {pathname &&
              matchPath({ path: "/integrations/*" }, pathname) !== null ? (
                <div
                  className="tab-pane fade active show"
                  id="kt_header_navs_tab_2"
                >
                  {/*begin::Wrapper*/}
                  <div className="d-flex flex-column flex-lg-row flex-lg-stack flex-wrap gap-2 px-4 px-lg-0">
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <Link
                        className={
                          pathname && pathname === "/integrations/ordable"
                            ? "btn btn-sm btn-primary fw-bold"
                            : "btn btn-sm btn-light-primary fw-bold"
                        }
                        to="/integrations/ordable"
                      >
                        Ordable
                      </Link>
                    </div>
                  </div>
                  {/*end::Wrapper*/}
                </div>
              ) : (
                ""
              )}
              {/*end::Tab panel*/}

              {/*begin::Tab panel*/}

              {/*end::Tab panel*/}
            </div>
            {/*end::Header tab content*/}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header navs*/}
    </div>
  );
};

export default Header;
